<template>
  <div class="list-box common-shadow clearfix">
    <span>{{checkBoxValue}}</span>
    <Checkbox-group v-model="checkBoxValue">
      <Checkbox v-for="(item,index) in proList" :key="index" :label="item.portPro" :value="item.id" :data-value="item.id"></Checkbox>

    </Checkbox-group>
  </div>
</template>

<script>
import {hideLoading, showLoading} from "@/utils/util";
import $api from "@/apiProvider";

export default {
  name: "PortArea",
  data(){
    return{
      proData:{},
      proList:[],
      areaData:{},
      areaList:[],
      areaType:1,
      checkBoxValue:[]
    }
  },
  created() {
    this.getAreaPro(1);
  },
  methods: {
    async getList() {
      showLoading()
      this.proData = {
        page: 1,
        rows: 500,
        pCode: 0
      }
      let res = await $api.shipQurty.request('querySysPortInfoList', this.proData);
      if (res.code === 1) {
        hideLoading()
        this.proList = res.data.list
      }
      else {
        hideLoading()
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getAreaPro(areaType) {
      showLoading()
      this.areaData.areaType = areaType;
      let res = await $api.shipQurty.request('queryPortAreaList', this.areaData);
      if (res.code === 1) {
        hideLoading()
        this.areaList = res.data.list
      }
      else {
        hideLoading()
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    }
  }
}

</script>

<style scoped>

</style>